import { GetAccountsResponse } from '@iwoca/lapi-client/edge';

import { buildRepaymentScheduleState } from './RepaymentScheduleHelper';
import {
    AD_HOC_AMOUNT_REPAYMENT_SCHEDULE_MODAL_DATA,
    REPAYMENT_SCHEDULE_MODAL_DATA
} from './RepaymentScheduleModal.actions';
import { mergeStates } from '../../../iwProvider/StoreHelper';

const initialState = {
    repayments: [],
    totalBalance: 0,
    totalInterest: 0,
    totalPrincipal: 0,
    totalRepayment: 0,
    totalFees: 0,
    hasFees: false,
    accountId: null
};

export type TSchedule = NonNullable<
    NonNullable<
        GetAccountsResponse['data']
    >['accounts'][number]['scheduled_payments']
>;

type TState = {
    repayments: NonNullable<TSchedule['schedule']>;
    totalBalance?: number;
    totalInterest: number;
    totalPrincipal: number;
    totalRepayment: number;
    totalFees: number;
    hasFees: boolean;
    accountId: string | null;
};

type TAction =
    | {
          type: typeof REPAYMENT_SCHEDULE_MODAL_DATA;
          schedule: TSchedule;
          accountId: string | null;
      }
    | {
          type: typeof AD_HOC_AMOUNT_REPAYMENT_SCHEDULE_MODAL_DATA;
          schedule: TSchedule;
          accountId: string | null;
      };

// eslint-disable-next-line import/no-default-export
export default function (
    state: TState = mergeStates(initialState),
    action: TAction
): TState {
    switch (action?.type) {
        case REPAYMENT_SCHEDULE_MODAL_DATA:
        case AD_HOC_AMOUNT_REPAYMENT_SCHEDULE_MODAL_DATA:
            const newState = {
                ...buildRepaymentScheduleState(action.schedule),
                accountId: action.accountId
            };
            return mergeStates(newState);

        default:
            return state;
    }
}
